import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useWidget } from "/imports/state/WidgetContext";
import { useUrlFilters } from "/imports/libs/url";
import api from "/imports/api/client";
import useFetch from "/imports/hooks/useFetch";
import { DataView } from "/imports/ui/components/shared";

function TermsView() {
  const navigate = useNavigate();
  const { slug, services, selectedLocation } = useWidget();
  const { filters } = useUrlFilters({ status: "enrolling" });

  const termServices = services?.filter((s) => s.categoryType === "category-service-term") || [];

  const {
    data: terms,
    loading,
    error
  } = useFetch(
    () => api.getTerms(slug, { sport: filters.sport, locationId: selectedLocation?._id, status: filters.status }),
    [slug, filters.sport, filters.status, selectedLocation?._id],
    { skip: !slug }
  );

  const heading = (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
        <IconButton size="small" onClick={() => navigate(`/${slug}`)} aria-label="Back to home" sx={{ ml: -0.5 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" fontWeight={700}>
          Programs & Terms
        </Typography>
      </Box>
      <Typography variant="body2" color="textSecondary" mb={3}>
        Enroll in our term-based courses and programs
      </Typography>
    </>
  );

  if (termServices.length === 0 && !loading) {
    return (
      <Box>
        {heading}
        <Alert severity="info">No programs are currently available for enrollment.</Alert>
      </Box>
    );
  }

  return (
    <Box>
      {heading}

      {/* TODO: filter UI (sport, status pills) */}

      <DataView loading={loading} error={error} data={terms} loadingMessage="Loading programs...">
        <Box>
          <Typography variant="body2" color="textSecondary">
            {terms?.terms?.length || 0} programs available
          </Typography>
          {/* TODO: terms list/grid UI */}
        </Box>
      </DataView>
    </Box>
  );
}

export default TermsView;
